"use strict";
exports.__esModule = true;
exports.SessionHasRoomsSync = exports.SessionHasRooms$ = exports.SessionIsLoading$ = exports.SessionLoaded$ = exports.SessionQuery = void 0;
var akita_1 = require("@datorama/akita");
var session_store_1 = require("./session.store");
var operators_1 = require("rxjs/operators");
exports.SessionQuery = akita_1.createQuery(session_store_1.SessionStore);
exports.SessionLoaded$ = exports.SessionQuery.select()
    .pipe(operators_1.filter(function (session) { return !!session.sessionId && !session.loading; }));
exports.SessionIsLoading$ = exports.SessionQuery.selectLoading();
exports.SessionHasRooms$ = exports.SessionQuery.select(function (session) { return !!session.basket.rooms.length; });
exports.SessionHasRoomsSync = function () { return Boolean(exports.SessionQuery.getValue().basket.rooms.length); };
//# sourceMappingURL=session.query.js.map